import { Card, Stack, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const loungeInfoContainer = css`
  background-color: #fafafa;

  & > div:not(:last-child) {
    margin-bottom: 16px;
  }
`;
const listStyles = css`
  display: inline;
  margin-inline-end: 4px;

  &:not(:last-child)::after {
    content: ', ';
  }
`;
const AvailabilityAccordion = _ref => {
  var _loungeInfo$amenities, _loungeInfo$condition;
  let {
    drawerText,
    loungeInfo
  } = _ref;
  const {
    openningFrom,
    openningTo,
    oppeningTitle,
    amenities: amenitiesText,
    location,
    condition: conditionText,
    terminal: terminalText
  } = drawerText;
  const InfoItem = _ref2 => {
    let {
      title,
      children
    } = _ref2;
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: 0,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: textVariants._14_BOLD,
        children: title
      }), children]
    });
  };
  return /*#__PURE__*/_jsxs(Card, {
    className: loungeInfoContainer,
    "data-testid": "availability-accordion-lounge-card",
    id: "availability-accordion-info-content",
    children: [/*#__PURE__*/_jsx(InfoItem, {
      title: oppeningTitle,
      children: /*#__PURE__*/_jsxs("div", {
        "data-testid": "availability-opening-hours",
        children: [openningFrom, " ", /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: loungeInfo.openAt
        }), ' ', openningTo, " ", /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: loungeInfo.closeAt
        })]
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: amenitiesText,
      children: /*#__PURE__*/_jsx("ul", {
        children: (_loungeInfo$amenities = loungeInfo.amenities) === null || _loungeInfo$amenities === void 0 ? void 0 : _loungeInfo$amenities.map((amenity, index) => /*#__PURE__*/_jsx("li", {
          className: listStyles,
          children: /*#__PURE__*/_jsx(Text, {
            spacing: 4,
            children: amenity === null || amenity === void 0 ? void 0 : amenity.name
          })
        }, amenitiesText + index))
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: location,
      children: /*#__PURE__*/_jsxs("div", {
        children: [terminalText, " ", loungeInfo.terminal]
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: conditionText,
      children: /*#__PURE__*/_jsx("ul", {
        children: (_loungeInfo$condition = loungeInfo.conditions) === null || _loungeInfo$condition === void 0 ? void 0 : _loungeInfo$condition.map((condition, index) => /*#__PURE__*/_jsx("li", {
          className: listStyles,
          children: /*#__PURE__*/_jsx(Text, {
            children: condition === null || condition === void 0 ? void 0 : condition.description
          }, index)
        }, conditionText + index))
      })
    })]
  });
};
export default AvailabilityAccordion;
//# sourceMappingURL=AvailabilityAccordion.js.map